import { Button, toast } from "@/components/ui";
import { TRACKERS } from "@/constants/Trackers";
import { trackEvent } from "@/lib/tracking";
import { useAddPatientTab } from "@/network/useAddPatientTab";
import { useRouter } from "@tanstack/react-router";
import { type LucideIcon, SquareUser } from "lucide-react";

export const OpenChartButton = ({
  patientId,
  tabName,
  search,
  buttonText = "Chart",
  icon = SquareUser,
}: {
  patientId: string;
  tabName: string;
  search?: Record<string, unknown>;
  buttonText?: string;
  icon?: LucideIcon;
}) => {
  const { navigate } = useRouter();
  const addPatientTab = useAddPatientTab();

  const openChart = async (patientId: string, tabName: string) => {
    trackEvent(TRACKERS.OPEN_CHART);
    try {
      await addPatientTab.mutateAsync({ patientId });

      // Navigate to specific tab with optional search params
      navigate({
        to: `/patient/$patientId/${tabName}`,
        params: {
          patientId,
        },
        ...(search && { search }),
      });
    } catch (error) {
      toast.error("Unable to open patient chart", {
        id: "add-patient-tab-error",
      });
    }
  };

  return (
    <Button
      key="open-chart"
      size="sm"
      variant="primary"
      leftIcon={icon}
      onClick={() => {
        openChart(patientId, tabName);
      }}
    >
      {buttonText}
    </Button>
  );
};
